import { addFormatToken } from '../format-functions';
import { getSeconds } from '../utils/date-getters';
addFormatToken('s', ['ss', 2], null, function (date) {
    return getSeconds(date).toString(10);
});
//# sourceMappingURL=second.js.map


//////////////////
// WEBPACK FOOTER
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/ngx-bootstrap/bs-moment/units/second.js
// module id = ../../../../ngx-bootstrap/bs-moment/units/second.js
// module chunks = 4